import PropTypes from 'prop-types';

export default PropTypes.shape({
    primaryColor: PropTypes.string,
    titleColor: PropTypes.string,
    descriptionColor: PropTypes.string,
    bgColor: PropTypes.string,
    backgroundTopColor: PropTypes.string,
    backgroundBottomColor: PropTypes.string
})